const sanitizeRegex = new RegExp(/[&\/\\#,+()$~%.'":*?<>{}]/g)

export default sanitizeRegex
